<div class="row">
  <div class='col info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <div class='info-list-2'>
          <info-list-item label='MFA Risk' labelTooltip="Pixalate's assessment of the risk of the app being deemed MFA."
            [lock]='isFreemium'>
            <risk-heat-meter #value [risk]='data?.mfa?.rating'></risk-heat-meter>
          </info-list-item>
          <info-list-item label='Ad Refresh Rate'
            labelTooltip='Number of Ad Impressions presented to the user, per hour.' [value]="data?.mfa?.noOfAdsPerHour"
            [lock]='isFreemium'>
          </info-list-item>
        </div>
      </div>
    </div>
  </div>
</div>